import {
  ProductImage, MainImage, MainImageContainer,
  Gallery, GalleryImage, GalleryImageContainer,
  Controls, GalleryImages, GalleryImagesContainer
} from './styles'

ProductImage.MainImage = MainImage
ProductImage.MainImageContainer = MainImageContainer
ProductImage.Gallery = Gallery
ProductImage.GalleryImage = GalleryImage
ProductImage.GalleryImageContainer = GalleryImageContainer
ProductImage.Controls = Controls
ProductImage.GalleryImages = GalleryImages
ProductImage.GalleryImagesContainer = GalleryImagesContainer

export default ProductImage
